import { render, staticRenderFns } from "./subscriptionAlertComponent.vue?vue&type=template&id=4f40eb7c"
import script from "./subscriptionAlertComponent.vue?vue&type=script&lang=js"
export * from "./subscriptionAlertComponent.vue?vue&type=script&lang=js"
import style0 from "./subscriptionAlertComponent.vue?vue&type=style&index=0&id=4f40eb7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports